var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTransactionMoneyTransfer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2538 26.1221C8.29082 24.2185 7.12028 21.7267 6.94726 19.085C6.52317 12.8477 11.6274 7.41905 18.3523 6.95485L30.3166 6.92701",
    stroke: "#20242E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.097 11.7352C30.061 13.6387 31.232 16.1304 31.405 18.7721C31.8291 25.0093 26.7247 30.4381 19.9964 30.9026L8.03513 30.9212",
    stroke: "#20242E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3904 5L31.4897 6.83112L29.6586 8.93045",
    stroke: "#20242E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.96191 32.8572L6.86258 31.0261L8.69369 28.9267",
    stroke: "#20242E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5 21.5923L21.5264 22.5199C21.8837 22.6835 22.2814 22.3899 22.2303 22.0003L21.9407 19.7906C21.9284 19.6861 21.939 19.5851 21.9723 19.4875C22.0057 19.3898 22.0585 19.3022 22.1309 19.2244L23.6362 17.6039C23.9039 17.3158 23.7494 16.8456 23.3629 16.7724L21.1838 16.3597C21.0796 16.3393 20.9853 16.2995 20.9009 16.2401C20.8166 16.1808 20.7486 16.1052 20.6971 16.0135L19.6279 14.0736C19.4381 13.7293 18.9433 13.7287 18.7527 14.0726L17.6732 16.0199C17.6268 16.1109 17.5626 16.1887 17.4806 16.2533C17.3985 16.3179 17.3053 16.3563 17.2008 16.3686L15.0235 16.798C14.6392 16.8738 14.4873 17.3421 14.7541 17.629L16.2687 19.2582C16.3465 19.3306 16.4013 19.4158 16.4332 19.5139C16.465 19.612 16.4708 19.7132 16.4504 19.8174L16.1832 22.0212C16.1359 22.4111 16.5359 22.7008 16.8916 22.5342L18.9129 21.5878C19.0046 21.5363 19.1027 21.5126 19.207 21.5167C19.3114 21.5207 19.409 21.5459 19.5 21.5923Z",
    fill: "#0E5CF4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTransactionMoneyTransfer);
export default __webpack_public_path__ + "static/media/ic-transaction-money-transfer.8f17d9abf6cab4b7d149ec9df937b81d.svg";
export { ForwardRef as ReactComponent };